<template>
    <div class="my-ui-xxbb-my-form-item-body">
        <div class="my-ui-xxbb-my-form-item-label">{{ label }}<span class="my-ui-xxbb-my-form-item-required"
                v-show="required">*</span></div>
        <slot class="my-ui-xxbb-my-form-item-content"></slot>
    </div>
</template>

<script>
export default {
    props: {
        pos: { // 位置, 0: 左, 1: 右,2,上
            type: Number,
            default: 0
        },
        label: {
            type: String,
            default: ''
        },
        required: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style>
.my-ui-xxbb-my-form-item-body {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.my-ui-xxbb-my-form-item-label {
    height: 30px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    line-height: 30px;
    font-size: 12px;
    font-weight: bolder;
    color: #333;
}

.my-ui-xxbb-my-form-item-content {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.my-ui-xxbb-my-form-item-required {
    height: fit-content;
    width: fit-content;
    box-sizing: border-box;
    margin-left: 5px;
    font-size: 12px;
    color: #F00;
    font-weight: bolder;
}
</style>